import cn from "classnames";
import Image from "next/image";
import { useState } from "react";

import { CatalogFiltersAttribute, CatalogFiltersOption } from "shared/catalog/CatalogPageContext";
import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";
import { Checkbox } from "ui/Checkbox";
import { useI18n } from "utils/with-i18n.utils";

export const CatalogFilters = (props: {hideGlobalFilters?: boolean}) => {
  const i18n = useI18n();
  const { filters, filtersOptions, toggleFilter, resetFilters } = useCatalogPageContext();
  const filtersKeys = Object.keys(filters) as CatalogFiltersAttribute[];
  
  return (
    <div className="select-none">
      <div className="flex flex-col gap-2">
        <div className="flex gap-3 items-center mb-3">
          <Image src="/images/catalog/icons/filters.svg" width={24} height={24} alt="filters" className="cursor-pointer" />
          <p className="text-xl font-semibold">{i18n.t('catalog.filters.title')}</p>
        </div>

        {!props.hideGlobalFilters && filtersKeys.map(filter => filters[filter].map(value => (
          <div key={value} className="flex gap-2 items-center py-1 px-3 w-max bg-white rounded-full border">
            <Image
              src="/images/catalog/icons/close.svg"
              width={12} height={12} alt="remove"
              className="cursor-pointer" 
              onClick={() => toggleFilter(filter as CatalogFiltersAttribute, value)}
             />
            <p>{filtersOptions[filter].find(o => o.value == value)?.label || ''}</p>
          </div>
        )))}

        {!props.hideGlobalFilters && filtersKeys.some(filter => filters[filter].length > 0) && (
          <div className="mt-3 mb-5 cursor-pointer" onClick={() => resetFilters()}>
            <p className="text-xs underline">{i18n.t('catalog.filters.reset')}</p>
          </div>
        )}
      </div>
      <FiltersSection attribute="brand" options={filtersOptions.brand} />
      <FiltersSection attribute="stock" options={filtersOptions.stock} />
      <FiltersSection attribute="price" options={filtersOptions.price} />
      <FiltersSection attribute="size" options={filtersOptions.size} />
      <FiltersSection attribute="storage" options={filtersOptions.storage} />
    </div>
  );
};


const FiltersSection = ({
  attribute,
  options
}: {
  attribute: CatalogFiltersAttribute;
  options: CatalogFiltersOption[];
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const i18n = useI18n();
  const { toggleFilter, filterValueIsChecked, optionIsPossible } = useCatalogPageContext();

  return (
    <>
      {options.length > 1 && (
        <div className="flex flex-col gap-5 py-5 border-t">
          <div className="flex justify-between cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
            <h3 className="text-lg font-semibold capitalize">
              {i18n.t(`catalog.filters.${attribute}.title`)}
            </h3>
            <Image src="/images/catalog/icons/filters-arrow.svg" width={18} height={9} alt="filter" className={isOpen ? '' : 'rotate-180'} />
          </div>

          {isOpen && (
            <div className="flex overflow-hidden flex-col gap-3">
              {options.map((option) => (
                <div
                  key={option.value}
                  className={cn("flex items-center", optionIsPossible(attribute, option.value) ? 'cursor-pointer' : 'opacity-50')}
                  onClick={() => optionIsPossible(attribute, option.value) && toggleFilter(attribute, option.value)}
                >
                  <Checkbox isChecked={filterValueIsChecked(attribute, option.value)} />
                  <p className="text-lg">{option.label}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}